var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card-title', [_vm._v(" Редактирование подразделения "), _c('div', {
    staticClass: "ml-5"
  }, [_c('v-btn', {
    staticClass: "mx-4",
    attrs: {
      "small": "",
      "color": "primary",
      "outlined": "",
      "to": "/subdivisions"
    }
  }, [_vm._v("Все подразделения")])], 1)]), _vm.subdivision !== null ? _c('SubdivisionForm', {
    attrs: {
      "subdivision": _vm.subdivision
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }